import moment from "moment";
import React from "react";

interface SubscriptionHistoryItem {
  type: "subscription";
  planName: string; // Nome do plano
  id: string; // ID da assinatura
  status: string; // Status da assinatura (ex: "active", "canceled")
  canceledAt: number | null; // Timestamp de cancelamento, se aplicável
  cancelAtPeriodEnd: boolean; // Indica se a assinatura será cancelada ao final do período
  currentPeriodEnd: number; // Timestamp do final do período atual
  date: number; // Data de referência para ordenação cronológica
  amount: number; // Valor do plano
}

interface PaymentHistoryItem {
  type: "payment";
  id: string; // ID do pagamento (fatura)
  amountPaid: number; // Valor pago
  currency: string; // Moeda usada para o pagamento
  paidAt: number; // Timestamp do pagamento efetuado
  subscription: string; // ID da assinatura associada ao pagamento
  date: number; // Data de referência para ordenação cronológica
  paymentType: string; // Tipo de pagamento (PRIMEIRO PAGAMENTO ou RENOVADO)
}

export type HistoryItem = SubscriptionHistoryItem | PaymentHistoryItem;

// Helper function to anonymize the ID
function cut(value: string) {
  const v = value.split("_")[1];
  return v.substring(0, 4) + "***" + v.substring(v.length - 4);
}
// Componente para renderizar um item do histórico
const HistoryItemComponent: React.FC<{ item: HistoryItem }> = ({ item }) => {
  if (item.type === "subscription") {
    return (
      <div className="flex w-full flex-row justify-between">
        <div>
          <p>
            <strong className="pr-2 text-xs font-semibold uppercase text-zinc-700 dark:text-zinc-300">
              {cut(item.id)}
            </strong>
          </p>
        </div>

        <div className="flex flex-1 flex-col">
          <p className="text-zinc-800 dark:text-zinc-200">
            Assinatura do plano
          </p>
        </div>

        <div className="flex flex-col items-end">
          <p
            className={`rounded-full border px-2 py-0.5 text-xs font-medium uppercase ${
              item.status === "active"
                ? "border-green-500 bg-green-200 text-green-600 dark:border-green-400 dark:bg-green-900 dark:text-green-300"
                : "border-red-500 bg-red-200 text-red-600 dark:border-red-400 dark:bg-red-900 dark:text-red-300"
            }`}
          >
            {item.status.toUpperCase()}
          </p>
          {item.canceledAt ? (
            <h5 className="text-xs font-bold text-zinc-600 dark:text-zinc-300">
              {moment(new Date(item.canceledAt * 1000)).format("L, HH:mm")}
            </h5>
          ) : (
            <h5 className="text-xs font-bold text-zinc-600 dark:text-zinc-300">
              <strong className="text-zinc-800 dark:text-zinc-100">ATÉ </strong>
              {moment(new Date(item.currentPeriodEnd * 1000)).format(
                "L, HH:mm",
              )}
            </h5>
          )}
        </div>
      </div>
    );
  } else if (item.type === "payment") {
    return (
      <div className="flex w-full flex-row justify-between text-sm">
        <p>
          <strong className="pr-2 text-xs font-semibold uppercase text-zinc-700 dark:text-zinc-300">
            {cut(item.subscription)}
          </strong>
          <span className="text-zinc-800 dark:text-zinc-200">
            PAGAMENTO {(item.amountPaid / 100).toFixed(2)}{" "}
            {item.currency.toUpperCase()}
          </span>
        </p>
        <div className="flex flex-col items-end">
          <p className="rounded-full border border-zinc-500 bg-zinc-200 px-2 py-0.5 text-xs font-medium uppercase text-zinc-600 dark:border-zinc-400 dark:bg-zinc-900 dark:text-zinc-300">
            {item.paymentType}
          </p>
          <h5 className="text-xs font-bold text-zinc-600 dark:text-zinc-300">
            {moment(new Date(item.paidAt * 1000)).format("L, HH:mm")}
          </h5>
        </div>
      </div>
    );
  }
  return (
    <p className="text-zinc-800 dark:text-zinc-200">
      Tipo de item desconhecido
    </p>
  );
};

export default HistoryItemComponent;
